<div class="tw-mb-6">
  <h1 class="tw-text-2xl tw-font-bold tw-text-gray-800 dark:tw-text-gray-100 tw-my-0">
    Clean Jobs
  </h1>
</div>
<div class="tw-flex tw-gap-2 tw-my-4">
  <button mat-raised-button [routerLink]="['upload']">Upload</button>
  <button
    [class.spinner]="refreshing"
    [disabled]="refreshing"
    mat-raised-button
    (click)="updateJobs()">
    Refresh
  </button>
</div>
<div class="container tw-p-0">
  <ag-grid-angular
    style="height: 100%;"
    [ngClass]="{ 'ag-theme-alpine': !(darkModeService.darkMode$ | async), 'ag-theme-alpine-dark': darkModeService.darkMode$ | async }"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [components]="components"
    [defaultColDef]="defaultColDef"
    enableCellTextSelection="true"
    ensureDomOrder="true"
    (gridReady)="onGridReady($event)">
  </ag-grid-angular>
</div>
